/* eslint-disable vue/multi-word-component-names */
// import 'babel-polyfill'
import '@/utils/rem';
import Vue from 'vue';
import './utils/element';
import App from './App.vue';
import store from './store';
import '@/styles/index.scss';
import router from './router';
import imgError from '@/utils/imgError';
import overflow from '@/utils/overflow';
import empty from '@/views/components/empty.vue';
import pagination from '@/components/pagination';
import MobileDetect from '@/utils/mobile-detect';


Vue.component('empty', empty);
Vue.config.productionTip = false;
Vue.directive('imgError', imgError);
Vue.directive('overflow', overflow);
Vue.component('pagination', pagination);


const mobileDetect = new MobileDetect(window.navigator.userAgent);
Vue.prototype.$ipad = Vue.prototype.$iPad = mobileDetect.tablet();

Vue.prototype.$cancelIpadCursor = function() {
    if (this.$ipad) {
        document.body.classList.add('no-cursor');
    };
};

Vue.prototype.$wordBarViewStyle = function() {
    return { paddingRight: this.$ipad ? '10rem' : '68.7rem' };
};


new Vue({
    router,
    store,
    render: (h) => h(App)

}).$mount('#app');
